import { Toaster as SonnerToaster } from 'sonner';

import type { ToasterProps } from './Toast.types';

/**
 * App-level toast container. Mount once, near the root.
 */
export function Toaster({ position = 'top-right', ...props }: ToasterProps) {
  return <SonnerToaster position={position} {...props} />;
}
